import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import LandContent from "./LandContent"

interface IProps {
    item : ILand
    onClose: () => void
    onOpenLogin?: () => void
}
const PlaceContent = (props: IProps) : JSX.Element => {
    return <LandContent {...props} /> 
} 

export default PlaceContent
